<template>
  <div class="cms-ger-fec">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="cabecalho">
        <App-Filtros
        :cpntMontarCampoF="cmsGerFecTabOnBuscarOptionsFiltroF"
        :cpntMontarCampoO="cmsGerFecTabOnBuscarOptionsFiltroO"
        :cpntMontarCampoV="cmsGerFecTabOnBuscarOptionsFiltroV"
        :cpntFiltroPredefinido="{ f: 'id_con_nome', o: '%', v: '' }"

        :cpntInputCoringa="{}"
        :cpntApiTabPer="tabper"
        @BUSCAR='cmsGerFecTabBuscarLinhas'
        ref="filtros">
          <div class="botao" v-if="cpntSelecionar === null">
            <App-Button :data-time="time" 
              :cpntId='botao.id'
              :cpntStatus='botao.status' 
              :cpntIcone='botao.icone'
              :cpntTexto='botao.texto'
              :cpntClass='botao.class'
              :cpntDisabled="botao.disabled"
              @onClick='botao.onClick'
            ></App-Button>
          </div>
        </App-Filtros>
      </div>

      <!-- SETA A TABELA -->
      <div class="tabela">
        <App-Tabela
        :cpntSetarFiltros="cmsGerFecTabSetarFiltros"
        :cpntMontarFiltros="cmsGerFecTabMontarFiltros"
        :cpntMontarWhere="cmsGerFecTabTabelaMontarWhere"
        :cpntCheckbox="checkbox"
        :cpntColuna="colunas"
        :cpntLinha="linha"
        :cpntMostrarMper="cpntSelecionar === null"
        :cpntApiTabPerFiltros="true"
        :cpntApiTabPerOrder="tabPerOrder"
        :cpntApiTabPer="tabper"
        :cpntBotaoExportar="cpntSelecionar === null ? exportar : undefined"
        :cpntBotaoExcluir="cpntSelecionar === null ? botaoExcluir : undefined"
        :cpntSetarValores="cmsGerFecTabSetarLinhas"
        :cpntApiRouter="route"
        :cpntApiWhere="where"
        :cpntApiOrder="order"
        :cpntApiField="field"
        :cpntApiFieldVirtual="fieldVir"
        :cpntApiMethods="'GET'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        @cpntSetarStatusLiberado="cmsGerFecTabSetarStatusLiberado"
        @TABELA_MARCAR_CHECKBOX='cmsGerFecTabMarcarCheckbox'
        ref="tabela">
          <!-- COLUNA ULTIMA ALTERAÇÃO -->
          <template v-slot:col_last="{ linha }">
            <span v-html="linha.last_user_usuario + '<br/>' + linha.last_at_ptbr"></span>
          </template>

          <!-- SETA A COLUNA DE VALOR -->
          <template v-slot:col__id_checkbox="{ linha }">
            <template v-for="(item, indexB) in linha.col_check">
              <App-Button :key="'col_check--bt--' + indexB" v-if="item.tipo === 'button'"
              :cpntStatus='liberado === "" ? item.status : liberado'
              :cpntTexto='item.texto'
              :cpntIcone='item.icone'
              :cpntDisabled='item.disabled'
              :cpntClass='item.class'
              :cpntExplica='item.explica'
              @onClick='() => { item.onClick(linha) }'
              ></App-Button>

              <App-Icone :key="'col_check--icone--' + indexB" v-else-if="item.tipo === 'icone'"
              :cpntStatus='liberado === "" ? item.status : liberado'
              :cpntTipo='item.icone'
              :cpntIconeClass='item.class'
              :cpntExplica='item.explica'
              ></App-Icone>
            </template>
          </template>

          <!-- COLUNA CONTATO -->
          <template v-slot:col_nome="{ linha }">
            <App-Button :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { cmsGerFecTabAbrirCadastro(linha.id_con) }'>
              <!-- COLOCA O NOME DO CONTATO -->
              <span v-html="linha.id_con_nome"></span>

              <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
              <span v-if='linha.id_con_pessoa === "j" && linha.id_con_empresa !== ""' v-html="' (' + linha.id_con_empresa + ')'"></span>

              <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
              <b v-if='linha.id_con_status !== "1"' v-html="'[Excluído]'"></b>
            </App-Button>
          </template>

          <!-- COLUNA CONTATO -->
          <template v-slot:col_codigo="{ linha }">
            <App-Button :cpntClass="[ 'btn', 'btn-primary', 'btn-sm' ]" @onClick='() => { cmsGerFecTabAbrirReciboComissao(linha.id) }'>
             CMS <span v-html="cmsGerFecTabFormatarNumeroDocumento(linha.id)"></span>
            </App-Button>
          </template>

          <!-- COLUNA CONTATO -->
          <template v-slot:col_periodo="{ linha }">
            <span v-html="linha.per_ini_ptbr"></span> até <span v-html="linha.per_fin_ptbr"></span>
          </template>

          <!-- COLUNA CONTATO -->
          <template v-slot:valores="{ valor, indexCV }">
            R$ <span v-html="cmsGerFecTabFormatarValor(valor, indexCV)"></span>
          </template>

          <template v-slot:col_por_total="{ valor, indexCV }">
            <span v-html="cmsGerFecTabFormatarValor(valor, indexCV)"></span>%
          </template>

          <!-- SETA PARA SELECIONAR O REGISTRO -->
          <template v-slot:col_selecionar="{ linha, indexL }">
            <App-Button @onClick='() => { cpntSelecionar(linha, indexL) }' :cpntClass="'btn btn-primary btn-sm'" :cpntIcone="'selecionar'"></App-Button>
          </template>
        </App-Tabela>
      </div>
    </template>

    <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO -->
    <router-view v-if="cpntSelecionar === null" :cpntFecharFormulario="cmsGerFecTabFecharFormulario"></router-view>
  </div>
</template>

<style scoped>
</style>

<style>
  /* CONFIGURAÇOES DOS BOTÕES DA COLUNA */
  /* -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= */
  .cms-ger-fec > .tabela > table > tbody > tr > td.col__id {
    width: 70px !important;
    min-width: 70px !important;
    max-width: 70px !important;
  }
    .cms-ger-fec > .tabela > table > tbody > tr > td.col__id > div > span > button {
      width: 30px;
      height: 30px;
      padding: 0px;
      margin: 2px;
    }
    .cms-ger-fec > .tabela > table > tbody > tr > td.col__id > div > span > img {
      margin: 0px 1px;
    }
    .cms-ger-fec > .tabela > table > tbody > tr > td.col__id > div > span > svg.fa-chart-line {
      font-size: var(--font-base-soma-15);
    }
</style>

<script>
  export default {
    props: {
      cpntFiltros: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntSelecionar: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Filtros': () => import('@/components/_geral/Filtros.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        liberado: 'carregando',
        checkbox: [],
        conferencia: [],
        tabper: 'CmsFec',
        route: '/comissao/fechamento/get/',
        botao: {
          status: '',
          texto: 'Novo Fechamento',
          class: [ 'btn', 'btn-info' ],
          mostrar: true,
          onClick: () => { this.$router.push({ name: 'comissao_ger_form', params: { id: 0 } }) }
        },
        colunas: [],
        linha: [],
        fazerOrdenacao: true,
        tabPerOrder: [
          { id: '0', nome: 'Última Alteração',      chave: 'last_at',     order: 'desc' },
          { id: '1', nome: 'Código Crescente',      chave: 'id',          order: 'asc' },
          { id: '2', nome: 'Ordem Alfabética',      chave: 'id_con_nome', order: 'asc' },
          { id: '3', nome: 'Código Decrescente',    chave: 'id',          order: 'desc' }
        ],  
        field: {},
        fieldVir: [],
        where: {},
        order: {},
        estruturaQueryGet: [
          [ 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order' ]
        ],
        botaoEditar: undefined,
        botaoExcluir: undefined,
        botaoReativar: undefined,
        botaoQtdeTotalEstoque: undefined,
        exportar: undefined,
        qtdeEstoqueTotal: undefined,
        acessos: {
          Financeiro: false
        }
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.cmsGerFecTabSetarStatusGeral('carregando')

      // FAZ A BUSCA DAS LINHAS NA TABELA
      this.cmsGerFecTabBuscarLinhas()
    },
    methods: {
      cmsGerFecTabFecharFormulario: function (atualizar) {
        // REDIRENCIONA PARA TELA SOLICITADA
        this.$router.push({ name: 'comissao_ger', params: {} })

        // VERIFICA SE DEVE ATUALIZAR A TELA
        if (atualizar === true) {
          this.cmsGerFecTabBuscarLinhas()
        }
      },
      cmsGerFecTabBuscarLinhas: function () {
        // CARREGA AS PERMISSOES DO USUARIO
        this.acessos.Financeiro = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 4 ], null, [ 9 ], null, [ 11 ], null, false) === true

        // INICIA A VARIAVEL DOS BOTÕES
        this.botaoEditar =  this.cmsGerFecTabEditar
        this.botaoExcluir = this.cmsGerFecTabExcluir
        this.exportar = null

        // SETA O WHERE QUE DEVE REALIZAR
        this.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

        // // SETA OS PARAMETROS PARA EXPORTAÇÃO
        // this.exportar = {
        //   format: [ 'xlsx', 'pdf' ],
        //   search: true,
        //   field: [  
        //     { id_con:                                   'Código.'                                   },
        //     { id_con_nome:                              'Vendedor'                                  }
        //   ]
        // }

        // REINICIA O VALOR DO CAMPO
        this.fazerOrdenacao = true

        // SETA AS COLUNAS DA TABELA
        var colunas = [
          { mPer: 3,                  chave: '_id',                                          tipo: 'checkbox', cpntValidaCheck: this.cmsGerFecTabValidarCheckbox },
          { mPer: 1,                  chave: 'codigo',          nome: 'Cód.'                                  },
          { mPer: 2,                  chave: 'nome',            nome: 'Vendedor'                              },
          { mPer: 2,                  chave: 'periodo',         nome: 'Período'                               },
          { mPer: 2,                  chave: 'vencimento_ptbr', nome: 'Vencimento'                            },
          { mPer: 2, slot: 'valores', chave: 'bc_total',        nome: 'BC Total'                              },
          { mPer: 2,                  chave: 'por_total',       nome: '%'                                     },
          { mPer: 2, slot: 'valores', chave: 'valor_total',     nome: 'Valor Comissão'                        },
          { mPer: 1,                  chave: 'last',            nome: 'Última Alteração'                      }
        ]

        // SETA OS CAMPOS QUE DEVE BUSCAR
        this.field = {
          id: null,
          status_fin: null,
          id_con: { j: { nome: null, empresa: null, pessoa: null, status: null } },
          per_ini: null,
          per_fin: null,
          vencimento: null,
          bc_total: null,
          por_total: null,
          valor_total: null,
          last_user: { j: { usuario: null } },
          last_at: null
        }

        // SETA OS CAMPOS VIRTUAIS QUE DEVE BUSCAR
        this.fieldVir = []

        // INCIA A VARIAVEL PARA REMOVER COLUNA
        var remover = []
        
        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        if ([ '', null, undefined ].indexOf(this.cpntSelecionar) === -1) {
          // ADICIONA O VALOR QUE NÃO DEVE COLOCAR ORDENAÇÃO MPER
          this.estruturaQueryGet[0].push('sem_order_mper')

          // LIMPA A ORDENAÇÃO DA TABELA
          this.order = { last_at: 'desc' }

          // REMOVE AS COLUNAS QUE NÃO PODEM SER COPAIDAS
          remover = remover.concat([ 'id_con' ])

          // CRIA UMA NOVA COLUNA PARA SELECIONAR
          colunas.unshift({ mPer: 3, chave: 'selecionar', nome: 'Selecionar' })
        }

        // REMOVE AS COLUNAS INFORMADAS
        if (remover.length >= 1) {
          colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
        }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && this.statusGeral === '') {
          this.cmsGerFecTabReiniciar()
        } else {
          this.cmsGerFecTabSetarStatusGeral('')
        }
      },
      cmsGerFecTabAbrirReciboComissao: function (id) {
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: 'comissoes', id: id, tipo: 'recibo', formato: 'html' } }).href, '_blank', {}, false)
      },
      cmsGerFecTabAbrirCadastro: function (id) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: false, tipo: 'contato', id: id }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar) => {
          if (atualizar === true) {
            this.cmsGerFecTabBuscarLinhas()
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      cmsGerFecTabTabelaMontarWhere: function (where) {
        // INICIA A VARIAVEL DE RETORNO
        var retorno = {}

        // FAZ A QUEBRA DE SINCRONIMOS DO VUE
        where = JSON.parse(JSON.stringify(where))
        
        // CONVERTE A OPERAÇÃO RECEBIDA
        if (where.o === '%') {
          where.o = 'like'
        }

        // VERIFICA SE DEVE SETAR ALGUM VALOR
        switch (where.f) {
          case 'codigo':
            retorno.where = { f: 'id', o: where.o, v: where.v }
            break

          case 'vencimento':
            // IMPORTA BIBLIOTECA DEPENDENTE
            var moment = require('moment')

            // VERIFICA SE TEM QUE GERAR O VALOR
            if ([ '', null, undefined ].indexOf(where.v._dataIni) !== -1) {
              where.v._dataIni = moment(where.v.dataIni, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }
            if ([ '', null, undefined ].indexOf(where.v._dataFim) !== -1) {
              where.v._dataFim = moment(where.v.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }

            // SETA O WHERE QUE DEVE REALIZAR
            if (where.o === '=') {
              retorno.where = { aAnd: [
                { f: 'vencimento', o: '>=', v: where.v._dataIni + ' 00:00:00' },
                { f: 'vencimento', o: '<=', v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if (where.o === '<>') {
              retorno.where = { aOr: [
                { f: 'vencimento', o: '<', v: where.v._dataIni + ' 00:00:00' },
                { f: 'vencimento', o: '>', v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if ([ '<=' ].indexOf(where.o) !== -1) {
              retorno.where = { aOr: [
                { f: 'vencimento', o: where.o, v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if ([ '>=' ].indexOf(where.o) !== -1) {
              retorno.where = { aOr: [
                { f: 'vencimento', o: '>', v: where.v._dataIni + ' 00:00:00' }
              ] }
            }
            break

          case 'last_user':
            retorno.where = { f: 'last_user', o: where.o, v: where.v.join() }
            break

          case 'financeiro':
            retorno.where = { f: 'status_fin', o: where.o, v: (where.v === 's' ? '1' : '0') }
            break

          case 'id_con_nome':
            if (where.o === '=') {
              retorno.where = { f: 'id_con', o: 'in', v: where.v.join() }
            } else {
              retorno.where = Object.assign(where, { m: 'contato', f: 'nome' })
            }
            break

          case 'id_con_cnpj':
          case 'id_con_cpf':
            retorno.where = { m: 'contato', f: 'cnpj_cpf', o: where.o, v: where.v }
            break

          case 'id_con_telefone':
            retorno.where = { aOr: [
              { m: 'contato', f: 'tel_res', o: where.o, v: where.v },
              { m: 'contato', f: 'tel_com', o: where.o, v: where.v },
              { m: 'contato', f: 'tel_cel', o: where.o, v: where.v }
            ] }
            break

          case 'id_con_email':
            retorno.where = { m: 'contato', f: 'email', o: where.o, v: where.v }
            break

          case 'id_con_estado':
            retorno.where = { m: 'contato', f: 'id_estado', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_cidade':
            retorno.where = { m: 'contato', f: 'id_cidade', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_tp_con':
            retorno.where = { m: 'contato', f: 'id_tp_con', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_pessoa':
            retorno.where = { m: 'contato', f: 'pessoa', o: where.o, v: where.v }
            break

          case 'busca':
            // SETA OS DADOS QUE DEVE BUSCAR
            retorno.where = { o: 's.ft', v: where.v }

            // REINICIA O VALOR DO CAMPO
            this.fazerOrdenacao = false
            break
        }

        // SETA O FLAG DO CAMPO
        retorno.fazerOrdenacao = this.fazerOrdenacao

        // RETORNA O VALOR MONTADO
        return retorno
      },
      cmsGerFecTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cmsGerFecTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.cmsGerFecTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      cmsGerFecTabSetarFiltros: function (callback, filtros, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltroSetarFiltros) === -1) {
            // VERIFICA SE TEM QUE ALTERAR O FILTRO DO CAMPO
            if ([ '', null, undefined ].indexOf(this.cpntFiltros) === -1 && ([ '', null, undefined ].indexOf(filtros) !== -1 || (Array.isArray(filtros) === true && filtros.length === 0))) {
              filtros = this.cpntFiltros
            }

            // SETA O FILTRO NA TELA
            this.$refs.filtros.cpntFiltroSetarFiltros(callback, filtros)
          } else {
            setTimeout(() => { this.cmsGerFecTabSetarFiltros(callback, filtros, (tentativa + 1)) }, 100)
          }
        }
      },
      cmsGerFecTabMontarFiltros: function (callback, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltrosMontar) === -1) {
            this.$refs.filtros.cpntFiltrosMontar(callback)
          } else {
            setTimeout(() => { this.cmsGerFecTabMontarFiltros(callback, (tentativa + 1)) }, 100)
          }
        }
      },
      cmsGerFecTabSetarLinhas: function (vetor) {
        // TRATA OS VALORES RECEBIDOS
        for (var index in vetor) {
          // SETA O ID DO REGISTRO
          vetor[index]._id = vetor[index].id

          // CHAMA A FUNÇÃO PARA MONTAR OS BOTÕES DA COLUNA CHECKBOX
          vetor[index].col_check = this.cmsGerFecTabValidarCheckbox(vetor[index])

          // FAZ O CHECK DA COLUNA ID
          vetor[index]._check_col__id = vetor[index].col_check.length === 0
        }

        // SETA OS VALORES RECEBIDOS
        this.linha = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cmsGerFecTabSetarStatusLiberado: function (status) {
        // SETA O STATUS DA TELA
        this.liberado = (status === '' || status === true) ? '' : (status === false ? 'carregando' : status)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cmsGerFecTabMarcarCheckbox: function (checked, value) {
        // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
        switch (checked) {
          case true:
            this.checkbox.push(value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== value)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cmsGerFecTabEditar: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE TEM REGISTRO PARA EDITAR
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else {
          // SETA OS IDS QUE DEVE EDITAR
          var ids = this.checkbox.length === 1 ? this.checkbox[0] : window.btoa(JSON.stringify(this.checkbox))

          // REDIRENCIONA PARA TELA SOLICITADA
          this.$router.push({ name: 'comissao_ger_form', params: { id: ids } })
        }
      },
      cmsGerFecTabExcluir: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE FOI SELECIONADO ALGUM REGISTRO
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm('Deseja realmente excluir o(s) vendedores(s) selecionado(s)?')) {
          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoExcluir = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO
          var formData = { j_id: this.checkbox }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/comissao/fechamento', 'DELETE', formData, (apiSuccess) => {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

            // MANDA ATUALIZAR A TABELA
            this.cmsGerFecTabBuscarLinhas()

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.botaoExcluir = this.cmsGerFecTabExcluir

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.cmsGerFecTabSetarStatusGeral)
        }
      },
      cmsGerFecTabOnBuscarOptionsFiltroF: function (callback) {
        // INICIA A VARIAVEL PARA FILTRAR OS DADOS DA VENDA
        var optionsCMS = []

        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // ADICIONA O OPTIONS
        optionsCMS = optionsCMS.concat([
          { id: 'codigo',       nome: 'Código' },
          { id: 'vencimento',      nome: 'Vencimento' },
          { id: 'last_user',    nome: 'Alterado pelo usuário' }
        ])

        // VERIFICA SE TEM PACOTE FINANCEIRO
        if (this.acessos.Financeiro === true) {
          optionsCMS.push({ id: 'financeiro', nome: 'Financeiro' })
        }

        // INICIA A VARIAVEL PARA ADICONAR A DEMANDA
        vetor.options = [
          // { slot: 'contato', mask: 'id_con' }
        ]

        // VERIFICA SE TEM O PACOTE COMISSOES
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, [ 51 ], null, null, null, false) === true) {
          vetor.options.push({ slot: 'vendedor', group: 'Vendedor', mask: 'id_con' })
        }

        // SETA AS OPÇÕES DO FILTRO
        vetor.options = optionsCMS.concat(vetor.options)

        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      cmsGerFecTabOnBuscarOptionsFiltroO: function (callback, valor) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // VERIFICA OS OPTIONS QUE DEVE COLOCAR
        switch (valor.f) {
          case 'financeiro':
          case 'codigo':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: '=',    nome: '=',          _formatar: [ 'id' ] }
            ]

            // SETA O VALOR SELEICONADO
            vetor.value = '='
            break

          case 'last_user':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: 'in',     nome: 'Igual' },
              { id: 'notIn',  nome: 'Diferente' }
            ]

            // SETA O VALOR SELEICONADO
            vetor.value = 'in'
            break
          
          case 'vencimento':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: '=',    nome: 'Igual' },
              { id: '<>',   nome: 'Diferente' }
            ]

            // SETA O VALOR SELEICONADO
            vetor.value = '='
            break
        }
        
        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      cmsGerFecTabOnBuscarOptionsFiltroV: function (callback, valor) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = { disabled: false }

        // INICIA A FUNÇÃO PARA FINALIZAR
        var finalizar = null

        // VERIFICA OS OPTIONS QUE DEVE COLOCAR
        switch (valor.f) {
          case 'codigo':
            vetor.tipo = 'input'
            break

          case 'vencimento':
            vetor = Object.assign(vetor, {
              multiple: false,
              tipo: 'seletor-data',
              optionInicialNome: '',
              value: '30'
            })
            break

          case 'financeiro':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: 's',    nome: 'Fechamento comissão no financeiro' },
              { id: 'n',    nome: 'Fechamento comissão sem financeiro' },
            ]

            // SETA O VALOR SELEICONADO
            vetor.value = '='
            break

          case 'last_user':
            // SETA A VARIAVEL
            finalizar = ''

            // FAZ A BUSCA DOS DADOS
            this.cmsGerFecTabBuscarUsuarios((options) => {
              vetor = Object.assign(vetor, {
                options: options,
                keyValue: 'id',
                keyMostra: [ 'usuario' ],
                tab: {
                  limparOptions: false,
                  coluna: [
                    { mPer: 1, chave: 'usuario', nome: 'Nome' },
                    { mPer: 1, chave: 'botao', nome: 'Excluir' }
                  ],
                  linha: [],
                  notIn: []
                }
              })

              // RETORNA O VALOR MONTADO PARA O CAMPO
              callback(vetor)
            })
            break
        }
        
        // RETORNA O VALOR MONTADO
        if (finalizar === null && Object.keys(vetor).length >= 2) {
          callback(vetor)
        }
      },
      cmsGerFecTabBuscarUsuarios: function (callback) {
        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, usuario: null } }

        // SETA BUSCA QUE DEVE REALIZAR
        queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'usuario', o: '<>', v: 'SuporteRF' } ] }

        // FAZ A BUSCA NA API
        this.$store.state.comunicaAPI('/usuario/get', 'POST', queryGet, (retorno) => {
          callback(retorno.data)
        }, this.cmsGerFecTabSetarStatusGeral)
      },
      cmsGerFecTabFormatarNumeroDocumento: function (valor) {
        return ((valor.length <= 4 ? ('0000' + valor).slice(-4) : valor))
      },
      cmsGerFecTabFormatarValor: function (valor, chave) {
        // VERIFICA SE O CAMPO TEM VALOR PADRÃO
        if (valor === '' && [ 'bc_total', 'por_total', 'valor_total' ].indexOf(chave) !== -1) {
          valor = null
        }

        // CASO NÃO TENHA VALOR, SETA O VALOR 0,00
        switch (valor) {
          case '':
            valor = ''
            break

          case null:
          case undefined:
            valor = '0,00'
            break

          default:
            if ([ 'por_total' ].indexOf(chave) !== -1) {
              valor = this.$store.state.FUN_MASK_VALOR('valorDecimal', valor)
            } else {
              valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor)
            }
            break
        }

        // RETORNA O VALOR MONTADO
        return valor
      },
      cmsGerFecTabValidarCheckbox: function (linha) {
        // INICIA A VARIAVEL PARA BOTOES
        var vetor = []
        
        // VERIFICA SE ESTÁ NO FINANCEIRO
        if (this.cmsGerFecTabValidarItemFinanceiro(linha) === true) {
          vetor.push({
            tipo: (this.acessos.Financeiro === true ? 'button' : 'icone'),
            status: '',
            icone: 'financeiro_pdv',
            explica: { mensagem: 'Já registrado no Financeiro' },
            onClick: (_linha) => { this.cmsGerFecTabAbrirFinanceiro(_linha.id) }
          })
        }

        // RETORNA SE PASSOU EM TODAS AS VERIFICAÇÕES
        return vetor
      },
      cmsGerFecTabValidarItemFinanceiro: function (linha) {
        return ([ '', null, undefined, '0' ].indexOf(linha.status_fin) === -1)
      },
      cmsGerFecTabAbrirFinanceiro: function (id) {
        // SETA O LINK DO FINANCEIRO
        var link = process.env.VUE_APP_URL_CS + '/app/financeiro/financeiro_rel.php?cts=' + this.$store.state.token.cts + '&cod_tp=51&cod_n=' + id

        // REDIRECIONA PARA TELA DO FINANCEIRO
        this.$store.state.OPEN_PAGE_CS(link, '_blank')
      }
    },
    watch: {
      '$route': function (routeAtual, routeAnterior) {
        if (routeAnterior.name !== 'comissao_ger_form' && routeAtual.name !== 'comissao_ger_form') {
          // SETA O STATUS DA PAGINA
          this.cmsGerFecTabSetarStatusGeral('carregando')

          // LIMPA OS VALORES PARA NÃO APRESENTAR ERRADO
          this.checkbox = []
          this.where = {}
          this.linha = []
          this.colunas = []

          // MANDA ATUALIZAR A TABELA
          setTimeout(() => { this.cmsGerFecTabBuscarLinhas() }, 500)
        }
      }
    }
  }
</script>
